export default {
    NO_MORTGAGE: 'no-mortgage',
    ONE: '1',
    TWO: '2',
    MORE_THAN_TWO: 'more-than-2',
};
